import { IShift } from "types/schedules";
import { StyledTotalHours } from "components/schedule/time_block";
import React, { useMemo } from "react";
import { useShiftTotalHoursHandler } from "../../hooks/schedule/useShiftTotalHoursHandler";

export interface IShiftsTotalHours {
  shifts: IShift[];
}

export const ShiftsTotalHours = ({ shifts }: IShiftsTotalHours) => {
  const shiftTotalHoursHandler = useShiftTotalHoursHandler();
  const totalHours = useMemo(
    () => {
      return shifts.reduce((total, shift) => {
        return total + shiftTotalHoursHandler(shift);
      }, 0);
    },
    [shifts]
  );
  return <StyledTotalHours>Total Hours: {totalHours}</StyledTotalHours>;
};
